export const STREAM_FILTER_STORAGE_KEY = 'bugherd.commentStream.filter';

export type StreamFilter = 'all' | 'comments' | 'activity';

const isStreamFilter = (value: string | null): value is StreamFilter =>
  value === 'all' || value === 'comments' || value === 'activity';

export const readStreamFilter = (
  storage: Pick<Storage, 'getItem'> = window.localStorage
): StreamFilter => {
  try {
    const value = storage.getItem(STREAM_FILTER_STORAGE_KEY);
    return isStreamFilter(value) ? value : 'all';
  } catch (_error) {
    return 'all';
  }
};

export const writeStreamFilter = (
  filter: StreamFilter,
  storage: Pick<Storage, 'setItem'> = window.localStorage
) => {
  try {
    storage.setItem(STREAM_FILTER_STORAGE_KEY, filter);
  } catch (_error) {
    // The filter is a local preference. Keep the in-memory selection if storage is unavailable.
  }
};
